import Icon from 'veui/components/Icon'

Icon.register({
  'live-broadcast-plus': {
    paths: [
      {
        d: 'M401 384a13.16 13.16 0 01-6.4 11l-128 82.29A17.85 17.85 0 01257 480c-2.46 0-4.9-.49-7.16-1.45-5.42-2.32-8.84-7.07-8.84-12.26V301.71c0-5.19 3.42-9.94 8.84-12.26a18.28 18.28 0 0116.76 1.29l128 82.26a13.16 13.16 0 016.4 11zm303 160h-96v-96a32 32 0 10-64 0v96h-96a32 32 0 100 64h96v96a32 32 0 1064 0v-96h96a32 32 0 100-64zm17.87-378.55a32 32 0 00-29.91-3.1L576 209.46V128a32 32 0 00-32-32H64a32 32 0 00-32 32v512a32 32 0 0032 32h256a32 32 0 100-64H96V160h416v160a32 32 0 1064 0v-41.46l96-39V384a32 32 0 1064 0V192a32 32 0 00-14.13-26.55z'
      }
    ],
    width: '768',
    height: '768'
  }
})
